export default "__VITE_ASSET__BAeE19V$__"